// @flow

import React from "react";

import { MdClose } from "react-icons/md";
import { useModal, OkButton, WarningModalIcon } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import { Modal, bindModal } from "../comum";

import "./modal-alerta.css";

const ModalAlerta = () => {
  const modal = useModal("ModalAlerta");
  const { mensagem, style = "warning" } = modal.props;

  const body = React.useMemo(() => {
    switch (style) {
      case "error":
        return (
          <div className="ModalAlerta__mensagem--erro">
            <MdClose />
            {mensagem}
          </div>
        );
      default:
        return <p>{mensagem}</p>;
    }
  }, [mensagem, style]);

  return (
    <Modal transition mountOnShow className="ModalAlerta" {...bindModal(modal)}>
      <Modal.Header closeButton />

      <Modal.Body>
        <div className="ModalAlerta__mensagem">
          <WarningModalIcon />
          {body}
        </div>

        <div className="ModalAlerta__rodape">
          <OkButton onClick={modal.close}>
            <Translate>configuracaoRelatorio.botaoOk</Translate>
          </OkButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAlerta;
